import type { UserRole } from '@fixflow/shared-types';

const ROLE_HOME: Record<UserRole, string> = {
  platform_admin: '/dashboard',
  tenant_admin: '/dashboard',
  store_manager: '/dashboard',
  technician: '/tech',
  front_desk: '/tickets',
  read_only: '/reports',
};

export function postLoginPath(role: UserRole): string {
  return ROLE_HOME[role] ?? '/dashboard';
}
